/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiDashboardGetDashboardGet } from '../fn/dashboard/api-dashboard-get-dashboard-get';
import { ApiDashboardGetDashboardGet$Params } from '../fn/dashboard/api-dashboard-get-dashboard-get';
import { apiDashboardGetDashboardGet$Plain } from '../fn/dashboard/api-dashboard-get-dashboard-get-plain';
import { ApiDashboardGetDashboardGet$Plain$Params } from '../fn/dashboard/api-dashboard-get-dashboard-get-plain';
import { GetDashboardQueryResult } from '../models/get-dashboard-query-result';

@Injectable({ providedIn: 'root' })
export class DashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiDashboardGetDashboardGet()` */
  static readonly ApiDashboardGetDashboardGetPath = '/api/Dashboard/GetDashboard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardGetDashboardGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardGetDashboardGet$Plain$Response(params?: ApiDashboardGetDashboardGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardQueryResult>> {
    return apiDashboardGetDashboardGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDashboardGetDashboardGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardGetDashboardGet$Plain(params?: ApiDashboardGetDashboardGet$Plain$Params, context?: HttpContext): Observable<GetDashboardQueryResult> {
    return this.apiDashboardGetDashboardGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDashboardQueryResult>): GetDashboardQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashboardGetDashboardGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardGetDashboardGet$Response(params?: ApiDashboardGetDashboardGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardQueryResult>> {
    return apiDashboardGetDashboardGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDashboardGetDashboardGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashboardGetDashboardGet(params?: ApiDashboardGetDashboardGet$Params, context?: HttpContext): Observable<GetDashboardQueryResult> {
    return this.apiDashboardGetDashboardGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetDashboardQueryResult>): GetDashboardQueryResult => r.body)
    );
  }

}
